<template>
  <div class="home">
    <svg id="icons" xmlns="http://www.w3.org/2000/svg">
      <symbol id="icon-arrow" viewBox="0 0 476.213 476.213">
        <polygon
          fill="inherit"
          points="347.5,324.393 253.353,418.541 253.353,0 223.353,0 223.353,419.033 128.713,324.393 107.5,345.607 
	238.107,476.213 368.713,345.606 "
        ></polygon>
      </symbol>
    </svg>

    <div class="slider-content">
      <div class="nav-wrapper">
        <div class="nav-arrows">
          <div class="nav-up" style="visibility: inherit; opacity: 1;" @click="clickSlideUp">
            <svg id="arrow-up">
              <use xlink:href="#icon-arrow"></use>
            </svg>
          </div>
          <div class="nav-line" style="display:none"></div>
          <div
            v-for="(item, index) in sliders"
            :key="'nav-'+item.id"
            class="nav-item"
            :class="{'active':isCurrentActiveIndex(index)}"
            @click="selectNavItem(index)"
          >
            <span class="label">
              <span class="first">0</span>
              <span class="second">{{index+1}}</span>
            </span>
            <div class="mark"></div>
          </div>
          <div class="nav-down" style="visibility: inherit; opacity: 1;" @click="clickSlideDown">
            <svg id="arrow-down">
              <use xlink:href="#icon-arrow"></use>
            </svg>
          </div>
        </div>
      </div>

      <div class="slider-wrapper">
        <!--
        <div class="slider-container" :class="'color-'+(currentActiveIndex+1)" ref="slider-container">
        -->
        <div class="slider-container hidden" :ref="'slider-container'">
          <div
            class="slide active"
            v-for="(item, index) in sliders"
            :key="'id-'+item.id"
            :ref="item.id"
            :data-item-id="item.id"
            :class="{'active-prod':isCurrentActiveIndex(index), 'next-active-prod': isNextActiveIndex(index)}"
          >
            <div class="slide-content txt">
              <div class="txt-wrapper">
                <img
                  class="right-image"
                  :src="item.rightImage"
                  :ref="item.id+'txt'"
                  :data-txt="item.id+'txt'"
                  :style="{  top: item.top + 'px' }"
                >
              </div>
              <section class="centered-container view-all-produts">
                <a
                  class="link link--arrowed"
                  href="#"
                  @click.prevent="$router.push({path:'/products'})"
                >
                  View all the products
                  <svg
                    class="arrow-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                  >
                    <g
                      fill="none"
                      stroke="#cf0021"
                      stroke-width="1.5"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                    >
                      <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                      <path
                        class="arrow-icon--arrow"
                        d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"
                      ></path>
                    </g>
                  </svg>
                </a>
              </section>
            </div>
            <div
              class="slide-content img"
              :ref="item.id+'img'"
              :data-img="item.id+'img'"
              :style="{  top: item.top + 'px' }"
            >
              <div
                class="banner-hover-text"
                :data-paragraph="item.id+'paragraph'"
                :ref="item.id+'paragraph'"
              >
                <div
                  class="red-border"
                  :data-paragraph-item-1="item.id+'paragraph-item-1'"
                  :ref="item.id+'paragraph-item-1'"
                  style="position:relative"
                ></div>
                <h1
                  v-html="item.longtxt"
                  :data-paragraph-item-2="item.id+'paragraph-item-2'"
                  :ref="item.id+'paragraph-item-2'"
                  style="position:relative"
                ></h1>
                <h4
                  v-html="item.smalltxt"
                  :data-paragraph-item-3="item.id+'paragraph-item-3'"
                  :ref="item.id+'paragraph-item-3'"
                  style="position:relative"
                ></h4>
                <div class="mobile-product" @click="exploreProduct(item)">
                  <img class="mobile-right-image" :src="item.mobileProduct" alt>
                </div>
                <a
                  href="#"
                  style="position:relative"
                  @click="exploreProduct(item)"
                  :data-paragraph-item-4="item.id+'paragraph-item-4'"
                  :ref="item.id+'paragraph-item-4'"
                  class="red-btn explore-btn"
                >
                  Explore
                  <img src="../assets/images/arrow-front.svg">
                </a>
              </div>
              <div class="msg" @click="clickSlideDown">
                <img src="../assets/images/arrow-front.svg">Scroll
              </div>
              <img
                :src="item.leftImage"
                alt
                :data-big-img="item.id+'BigImg'"
                :ref="item.id+'BigImg'"
                :style="{  top: item.top + 'px' }"
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="social-wrapper">
        <ul class="foot-desc">
          <li>Copyright © 2019 henna speedy. All Rights Reserved</li>
          <li class="social">
            <a href="#">
              <i class="fa fa-facebook"></i>
            </a>
            <a href="#">
              <i class="fa fa-twitter"></i>
            </a>
            <a href="#">
              <i class="fa fa-instagram"></i>
            </a>
          </li>
          <li class="design-by" style="display:none">
            Site designed by
            <a href="https://www.webdesign366.com/" target="blank">
              <img src="../assets/images/366-logp.png">
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!--
    <div style="min-height:700px;background-color:yellow"></div>
    <div class="spacer s1" id="sec1">
      <div class="box2" style="background-color: #8DBBE0;width:400px;height:400px">
        <p>One</p>
        <a href="#" class="viewsource">view source</a>
      </div>
    </div>
    <div style="min-height:500px;background-color:white"></div>
    <div style="min-height:500px;background-color:white"></div>
    -->
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from "@/components/HelloWorld.vue";
/*
import ScrollMagic from "scrollmagic/scrollmagic/uncompressed/ScrollMagic";
import "scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap";
import "scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators";
import TweenMax from "gsap/src/uncompressed/TweenMax";
import TimelineMax from "gsap/src/uncompressed/TimelineMax";
*/

import Vue from "vue";
import debounce from "lodash.debounce";
//import addWheelListener from "@/components/AddWheelListener.js";
//import normalizeWheel from "normalize-wheel";

export default {
  name: "home",
  components: {},
  computed: {
    currentActiveIndex() {
      let me = this;
      if (me.activeSlideIndex == me.sliders.length) {
        me.activeSlideIndex = 0;
      } else if (me.activeSlideIndex == -1) {
        me.activeSlideIndex = me.sliders.length - 1;
      }
      return me.activeSlideIndex;
    },
    nextActiveIndex() {
      let me = this,
        nextActiveSlideIndex = me.activeSlideIndex,
        direct = me.slideDirection;

      if (direct == "up") {
        //nextActiveSlideIndex--;
        nextActiveSlideIndex -= me.slideStepSize;
      } else if (direct == "down") {
        //nextActiveSlideIndex++;
        nextActiveSlideIndex += me.slideStepSize;
      }

      if (nextActiveSlideIndex == me.sliders.length) {
        nextActiveSlideIndex = 0;
      } else if (nextActiveSlideIndex == -1) {
        nextActiveSlideIndex = me.sliders.length - 1;
      }

      return nextActiveSlideIndex;
    }
  },
  data() {
    return {
      activeSlideIndex: 0,
      displayActiveSlideIndex: 0,
      slideDirection: "",
      slideStepSize: 1,
      slideRefs: [],
      bigImage: null,
      smallImage: null,
      //sliders: Sliders,
      scrollPos: 0,
      isAnimating: false,
      pageMounted: false,
      triggerBeforeFirstAnim: false,
      sliders: []
    };
  },

  beforeRouteUpdate(to, from, next) {
    // just use `this`
    //this.name = to.params.name;
    console.log("Before route update");
    next();
  },
  /*
  beforeRouteEnter(to, from, next) {
    // called before the route that renders this component is confirmed.
    // does NOT have access to `this` component instance,
    // because it has not been created yet when this guard is called!
    console.log("beforeRouteEnter");
    console.log("to", to);
    next(vm => {
      if (to.query.id) {
        //vm.$router.push({name:'home'});
        //location.reload();
        //window.location = "http://localhost:8082/#/";
        window.location = vm.$root.siteRoot();
      }
      // access to component instance via `vm`
    });
  },
  */
  created() {
    this.$root.loadingQueueSize++;
    //console.log("page created");
    this.sliders = [];
    this.sliders = Sliders;
  },
  mounted() {
    this.initSlide();
    this.$root.initBody();
    //this.$forceUpdate();
    this.$root.loadingQueueSize--;
    /*
    $(".slider-container").imagesLoaded(function() {
      // images have loaded
    });
    */

  /*
   $('.slider-container').imagesLoaded()
  .always( function( instance ) {
    console.log('all images loaded');
  })
  .done( function( instance ) {
    console.log('all images successfully loaded');
  })
  .fail( function() {
    console.log('all images loaded, at least one is broken');
  })
  .progress( function( instance, image ) {
    var result = image.isLoaded ? 'loaded' : 'broken';
    console.log( 'image is ' + result + ' for ' + image.img.src );
  });
  */
    
   //console.log("image loader", $(".slider-container").imagesLoaded)
    $(".slider-container").removeClass("hidden");
  },
  updated() {
    //console.log("page updated");
  },
  methods: {
    uniqueId() {
      let time = new Date().getTime();
      return time;
    },
    isActiveOld(index) {
      if (this.triggerBeforeFirstAnim) {
        return true;
      } else if (!this.triggerBeforeFirstAnim && index == 0) {
        return true;
      }
      return false;
    },
    isCurrentActiveIndex(index) {
      return this.currentActiveIndex == index ? true : false;
    },
    isCurrentActiveDisplayIndex(index) {
      return this.displayActiveSlideIndex == index ? true : false;
    },
    isNextActiveIndex(index) {
      return this.nextActiveIndex == index ? true : false;
    },
    getNextActiveIndex() {
      let me = this,
        nextActiveSlideIndex = me.activeSlideIndex,
        direct = me.slideDirection;

      if (direct == "up") {
        //nextActiveSlideIndex--;
        nextActiveSlideIndex -= me.slideStepSize;
      } else if (direct == "down") {
        //nextActiveSlideIndex++;
        nextActiveSlideIndex += me.slideStepSize;
      }

      if (nextActiveSlideIndex == me.sliders.length) {
        nextActiveSlideIndex = 0;
      } else if (nextActiveSlideIndex == -1) {
        nextActiveSlideIndex = me.sliders.length - 1;
      }

      return nextActiveSlideIndex;
    },
    initClickOnNumbers() {},
    destroyClickOnNumbers() {},
    initTouchEvents() {
      let me = this;
      var myElement = document.getElementById("app");
      var mc = new Hammer(myElement);
      mc.get("pan").set({ direction: Hammer.DIRECTION_ALL });

      mc.on(
        "panup",
        me.$_debounce(function(ev) {
          //function(ev) {
          //console.log("panup");
          if (!me.isAnimating) {
            me.slideUp();
          }
          //return false;
        }, 100)
        //}
      );
      mc.on(
        "pandown",
        me.$_debounce(function(ev) {
          //function(ev) {
          //console.log("pandown");
          if (!me.isAnimating) {
            me.slideDown();
          }
          //return false;
        }, 100)
        //}
      );
    },
    initMouseWhell() {
      let me = this;
      let MouseWheelHandler = me.onMouseWheel;
      if (document.addEventListener) {
        document.addEventListener("mousewheel", MouseWheelHandler, false); //IE9, Chrome, Safari, Oper
        document.addEventListener("wheel", MouseWheelHandler, false); //Firefox
      } else {
        document.attachEvent("onmousewheel", MouseWheelHandler); //IE 6/7/8
      }
    },
    destroyMouseWheel() {
      let me = this;
      //console.log("destroyMouseWheel");
      let MouseWheelHandler = me.onMouseWheel;
      if (document.addEventListener) {
        document.removeEventListener("mousewheel", MouseWheelHandler, false); //IE9, Chrome, Safari, Oper
        document.removeEventListener("wheel", MouseWheelHandler, false); //Firefox
      } else {
        document.detachEvent("onmousewheel", MouseWheelHandler); //IE 6/7/8
      }
    },
    onMouseWheel: debounce(
      function(e) {
        let me = this;
        //console.log("on mouse wheell");
        // cross-browser wheel delta
        e = window.event || e;
        var delta = Math.max(
          -1,
          Math.min(1, e.wheelDelta || -e.deltaY || -e.detail)
        );
        me.destroyMouseWheel();
        if (me.isAnimating) {
          return false;
        }

        if (!me.isAnimating) {
          console.log("on mouse wheel", delta);
          //scrolling down?
          if (delta < 0) {
            me.slideDown();
          }
          //scrolling up?
          else {
            me.slideUp();
          }
        }

        return false;
      },
      280,
      {
        leading: true,
        trailing: false
      }
    ),
    initSlide() {
      //console.log("initSlide");
      let me = this;

      //this.$forceUpdate();

      this.activeSlideIndex = 0;
      this.slideStepSize = 1;

      //init the first background color
      $(".slider-container").css({
        "background-color": me.sliders[me.getNextActiveIndex()].color
      });

      me.initMouseWhell();
      me.initTouchEvents();
    },

    exploreProduct(item) {
      this.$router.push({
        name: "product-details",
        params: { productId: item.productId }
      });
    },
    clickSlideUp: debounce(function() {
      this.slideUp();
    }, 280),
    clickSlideDown: debounce(function() {
      this.slideDown();
    }, 280),
    slideUp() {
      this.slideTo("up");
    },
    slideDown() {
      this.slideTo("down");
    },
    selectNavItem: debounce(
      function(index) {
        //console.log("click on selectNav item", index);
        let me = this;

        if (me.isAnimating) {
          return;
        }

        let diff = index - me.activeSlideIndex;
        if (diff > 0) {
          me.slideStepSize = Math.abs(diff);
          me.slideDown();
        } else if (diff < 0) {
          me.slideStepSize = Math.abs(diff);
          me.slideUp();
        }
      },
      150,
      {
        leading: false,
        trailing: true
      }
    ),
    slideTo(direct) {
      let me = this;

      if (me.isAnimating) {
        return;
      }

      me.slideDirection = direct;

      if (!me.triggerBeforeFirstAnim) {
        me.triggerBeforeFirstAnim = true;
      }

      me.animSlide(direct);
    },
    animSlide(direct) {
      let me = this;

      me.destroyMouseWheel();

      console.log("this.$refs", this.$refs);
      //me.$forceUpdate();
      //Vue.forceUpdate();

      let eltToGoUp = null,
        eltToGoDown = null,
        $eltToGoUp = null,
        $eltToGoDown = null,
        timeUp = 0,
        timedown = 0,
        easeUp = "",
        easeDown = "";
      //console.log("direct", direct);

      let activeId = this.sliders[this.activeSlideIndex].id,
        nextActiveId = this.sliders[me.getNextActiveIndex()].id,
        $activeSlide = $("div.slide[data-item-id=" + activeId + "]"),
        $nextActiveSlide = $("div.slide[data-item-id=" + nextActiveId + "]");

      let activeTxt = this.$refs[
          this.sliders[this.activeSlideIndex].id + "txt"
        ],
        $activeTxt = $("[data-txt]", $activeSlide);

      let nextActiveTxt = this.$refs[
          this.sliders[me.getNextActiveIndex()].id + "txt"
        ],
        $nextActiveTxt = $("[data-txt]", $nextActiveSlide);

      let activeImg = this.$refs[
          this.sliders[this.activeSlideIndex].id + "img"
        ],
        $activeImg = $("[data-img]", $activeSlide);

      let nextActiveBigImg =
          me.$refs[me.sliders[me.getNextActiveIndex()].id + "BigImg"],
        $nextActiveBigImg = $("[data-big-img]", $nextActiveSlide);

      let activeTxtBlock = this.$refs[
          this.sliders[this.activeSlideIndex].id + "paragraph"
        ],
        $activeTxtBlock = $("[data-paragraph]", $activeSlide);

      let nextActiveTxtBlock =
          me.$refs[me.sliders[me.getNextActiveIndex()].id + "paragraph"],
        $nextActiveTxtBlock = $("[data-paragraph]", $nextActiveSlide);
      let nextActiveTxtBlockItem1 =
          me.$refs[me.sliders[me.getNextActiveIndex()].id + "paragraph-item-1"],
        $nextActiveTxtBlockItem1 = $(
          "[data-paragraph-item-1]",
          $nextActiveSlide
        ),
        nextActiveTxtBlockItem2 =
          me.$refs[me.sliders[me.getNextActiveIndex()].id + "paragraph-item-2"],
        $nextActiveTxtBlockItem2 = $(
          "[data-paragraph-item-2]",
          $nextActiveSlide
        ),
        nextActiveTxtBlockItem3 =
          me.$refs[me.sliders[me.getNextActiveIndex()].id + "paragraph-item-3"],
        $nextActiveTxtBlockItem3 = $(
          "[data-paragraph-item-3]",
          $nextActiveSlide
        ),
        nextActiveTxtBlockItem4 =
          me.$refs[me.sliders[me.getNextActiveIndex()].id + "paragraph-item-4"],
        $nextActiveTxtBlockItem4 = $(
          "[data-paragraph-item-4]",
          $nextActiveSlide
        );

      //let quickTime = 1.00,
      let quickTime = 0.8,
        longtime = quickTime;
      /*
      let easeanim = CustomEase.create(
        "custom",
        "M0,0 C0.084,0.61 0.1,0.682 0.184,0.808 0.238,0.889 0.378,0.974 1,1"
      );
      */

      //let easeanim =  CustomEase.create("custom", "M0,0 C0.084,0.61 0.533,0.891 0.616,0.914 0.836,0.974 0.334,0.866 1,1");
      //let easeanim =  CustomEase.create("custom", "M0,0 C0.084,0.61 0.429,0.891 0.512,0.916 0.708,0.974 0.746,0.988 1,1")
      let easeanim = CustomEase.create(
        "custom",
        "M0,0 C0.134,0.578 0.503,0.83 0.58,0.882 0.73,0.982 0.874,0.976 1,1"
      );

      //let easeanim = Expo.easeOut;
      if (direct == "up") {
        /*
        eltToGoUp = activeImg;
        eltToGoDown = activeTxt;
        */
        $eltToGoUp = $activeImg;
        $eltToGoDown = $activeTxt;

        timedown = quickTime;
        timeUp = longtime;
        easeUp = easeanim;
        easeDown = easeanim;
      } else if (direct == "down") {
        /*
        eltToGoUp = activeTxt;
        eltToGoDown = activeImg;
        */
        $eltToGoUp = $activeTxt;
        $eltToGoDown = $activeImg;

        timedown = longtime;
        timeUp = quickTime;
        easeUp = easeanim;
        easeDown = easeanim;
        /*
        easeDown = CustomEase.create(
          "custom",
          "M0,0 C0.426,0 0.502,0.05 0.652,0.198 0.752,0.297 0.722,0.562 1,0.986"
        );*/
      }

      var tl = new TimelineMax({
        paused: true,
        onStart: elt => {
          me.isAnimating = true;
        },
        onComplete: elt => {
          if (direct == "up") {
            me.activeSlideIndex -= me.slideStepSize;
          } else if (direct == "down") {
            me.activeSlideIndex += me.slideStepSize;
          }

          /*
          $(eltToGoUp[0]).css({
            top: "0px"
          });
          $(eltToGoDown[0]).css({
            top: "0px"
          });
          */
          $eltToGoUp.css({
            top: "0px"
          });
          $eltToGoDown.css({
            top: "0px"
          });
          me.destroyMouseWheel();

          me.slideStepSize = 1;
          me.isAnimating = false;
          me.initMouseWhell();
        }
      });
      /*
      let eltToGoUpHeight = $(eltToGoUp[0]).outerHeight(),
        eltToGoDownHeight = $(eltToGoDown[0]).outerHeight();
        */
      let eltToGoUpHeight = $eltToGoUp.outerHeight(),
        eltToGoDownHeight = $eltToGoDown.outerHeight();
      //Animation of the activated slide
      /////////////////////////////////////////////
      tl.to(
        $eltToGoUp[0],
        timeUp,
        {
          top: "-" + eltToGoUpHeight + "px",
          scale: 1,
          ease: easeUp
        },
        0.15
      );
      tl.to(
        $eltToGoDown[0],
        timedown,
        {
          top: eltToGoDownHeight + "px",
          scale: 1,
          ease: easeDown
        },
        0.15
      );
      //animation of the text
      tl.fromTo(
        $activeTxtBlock[0],
        0.1,
        {
          //left: "0"
          opacity: "1"
        },
        {
          opacity: "0"
          //left: "30%",
          //ease: Elastic.easeOut
          //ease: Back.easeOut
        },
        0
      );
      //animation of the background

      tl.to(
        //me.$refs["slider-container"],
        $(".slider-container"),
        0.7,
        {
          /*          
          colorProps: {
            //backgroundColor: "" + Sliders[me.getNextActiveIndex()].color
            backgroundColor: "rgb(102,255,51)",
          },                    
          */
          //opacity: 1,
          backgroundColor: "" + me.sliders[me.getNextActiveIndex()].color,
          ease: Linear.easeNone
        },
        0
      );

      //animation of the next slide
      /////////////////////////////////////
      tl.fromTo(
        $nextActiveBigImg[0],
        0.8,
        {
          scale: 1,
          ease: Power3.easeIn
        },
        {
          scale: 1.2
          //ease: easeDown
        },
        0
      );
      tl.fromTo(
        $nextActiveTxt[0],
        0.8,
        {
          scale: 1,
          ease: Power3.easeIn
        },
        {
          scale: 1.2
          //ease: easeDown
        },
        0
      );
      //$(nextActiveTxtBlock[0]).css({ opacity: "1", left: "0px" });
      $nextActiveTxtBlock.css({ opacity: "1", left: "0px" });

      tl.fromTo(
        $nextActiveTxtBlockItem1[0],
        0.9,
        {
          left: "0"
        },
        {
          left: "40%",
          ease: Power3.easeOut
        },
        0
      );
      tl.fromTo(
        $nextActiveTxtBlockItem2[0],
        0.9,
        {
          left: "0"
        },
        {
          left: "40%",
          ease: Power3.easeOut
        },
        0.1
      );
      tl.fromTo(
        $nextActiveTxtBlockItem3[0],
        0.8,
        {
          left: "0"
        },
        {
          left: "40%",
          ease: Power2.easeOut
        },
        0.25
      );
      tl.fromTo(
        $nextActiveTxtBlockItem4[0],
        0.7,
        {
          left: "0"
        },
        {
          left: "40%",
          ease: Power1.easeOut
        },
        0.3
      );

      tl.play();
    }
  }
};
</script>


<style lang="stylus" scoped>
.slider-container .slide-content img {
}

.slider-container .slide-content img.right {
  position: absolute;
  top: 0px;
  left: 0px;
}

.slider-container .slide-content img.left {
  position: relative;
}

.slide-content.txt {
  position: absolute;
}

.slider-container .slide-content .txt-wrapper {
  height: 100%;
  overflow: hidden;
  height: auto;
}

.slider-container .slide-content .txt-wrapper img {
  position: relative;
}

.slider-container .slide-content.txt {
  background: transparent;
}

.slider-content .slide {
  position: absolute;
  top: 0px;
  left: 0px;
}

.slide.active .view-all-produts {
  visibility: hidden;
}

.slide.active.active-prod .view-all-produts {
  visibility: visible;
}

.slide.active.next-active-prod {
  z-index: 8;
}

.slide.active.active-prod {
  z-index: 9;
}

.slide.active.next-active-prod .txt-wrapper img {
  z-index: 8;
}

.slide.active.active-prod .txt-wrapper img {
  z-index: 9;
}

.nav-wrapper {
  z-index: 91;
}

.slider-content .slide.active .img, .slider-content .slide.active .txt {
  transform: unset !important;
  position: absolute;
  top: 0px;
}

.nav-arrows .nav-item {
  padding: 0px 10px;
  margin: 8px 0px;
  position: relative;
  left: 41px;
  cursor: pointer;
  width: 48px;
}

.nav-wrapper .nav-up, .nav-wrapper .nav-down {
  margin-left: 34px;
}

.nav-arrows .nav-item.active {
}

.nav-arrows .nav-item div.mark {
  position: absolute;
  background-color: transparent;
  height: 2px;
  padding: 0;
  width: 60px;
  margin-left: -70%;
}

.nav-item.active span {
  color: #cf152d;
}

.nav-arrows .nav-item.active div.mark {
  background-color: #cf152d !important;
}

.nav-arrows .nav-item span.label {
  font-weight: 600;
  display: inline-block;
}

.nav-arrows .nav-item span.label span {
  display: inline-block;
  width: 14px;
  font-size: 18px;
}

.nav-arrows .nav-item span.label .first {
}

.nav-arrows .nav-item span.label .second {
}

.slide .banner-hover-text {
  /* opacity: 0; */
  /* opacity: 0 !important; */
}

.slide.active-prod .banner-hover-text {
  /* opacity: 1; */
  /* opacity: 1 !important; */
}

.msg {
  display: inline-block;
  white-space: nowrap;
  font-size: 12px;
  -moz-transform: rotate(-90deg);
  -moz-transform-origin: center center;
  -webkit-transform: rotate(-90deg);
  -webkit-transform-origin: center center;
  -ms-transform: rotate(-90deg);
  -ms-transform-origin: center center;
  position: absolute;
  bottom: 20%;
  left: 30%;
  font-weight: bold;
  color: #fff;
  z-index: 999;
}

.msg img {
  width: 22px !important;
  transform: rotate(180deg);
  margin-right: 10px;
}

.slider-container .slide-content img {
  position: relative;
}

.slider-content .slide.active .img {
  overflow: hidden;
}

.mobile-product {
  display: none;
}

/*
.right-image {
  border-radius: 65px 0 65px 0;
  -webkit-border-radius: 65px 0 65px 0;
  -moz-border-radius: 65px 0 65px 0;
}
*/
.slider-container .slide-content .txt-wrapper, .slider-container .slide-content .txt-wrapper img {
  -webkit-border-radius: 65px 0 65px 0 !important;
  -moz-border-radius: 65px 0 65px 0 !important;
  border-radius: 65px 0 65px 0 !important;
  -khtml-border-radius: 65px 0 65px 0 !important;
  overflow: hidden;
}

.slider-container .slide-content .txt-wrapper img {
}

.slider-container.color-1 {
  background-color: #cbd0d6;
  /*
  -webkit-transition: background-color 800ms linear;
  -ms-transition: background-color 800ms linear;
  transition: background-color 800ms linear;
  */
}

.slider-container.color-2 {
  background-color: #e1a8ab;
  background-color: #F0D5D6;
  /*
  -webkit-transition: background-color 800ms linear;
  -ms-transition: background-color 800ms linear;
  transition: background-color 800ms linear;
  */
}

.slider-container.color-3 {
  background-color: #cedfb3;
  /*
  -webkit-transition: background-color 800ms linear;
  -ms-transition: background-color 800ms linear;
  transition: background-color 800ms linear;
  */
}

.slider-container.color-4 {
  background-color: #dbcbb8;
  /*
  -webkit-transition: background-color 800ms linear;
  -ms-transition: background-color 800ms linear;
  transition: background-color 800ms linear;
  */
}

.slide-content .centered-container {
  background: transparent;
}

.loading:before {
  background: #cf152d;
}

/*
::-webkit-scrollbar {
  width: 0px !important;
}
*/
/*
.banner-hover-text{
  width:100%;
  left:0;
} */
.banner-hover-text h1 {
  max-width: 640px;
}

.hidden {
  visibility: hidden;
}

@media (max-width: 1440px) {
  .slider-container .slide-content .txt-wrapper {
    margin-top: 0;
    margin-left: 0;
  }

  .banner-hover-text, .banner-hover-text .red-border, .banner-hover-text h1, .banner-hover-text h4, .banner-hover-text a {
    left: 4% !important;
  }
}

@media (max-width: 1024px) {
  .mobile-product {
    display: block;
    cursor: pointer;
  }

  .mobile-product img {
    /* width: 150px !important; */
    margin-bottom: 25px;
    width: 200px !important;
    margin-left: 10px;
  }

  .explore-btn {
    display: none;
  }
}

@media (max-width: 768px) {
  .mobile-right-image {
    border-radius: 30px 0 30px 0;
    -webkit-border-radius: 30px 0 30px 0;
    -moz-border-radius: 30px 0 30px 0;
  }

  .msg {
    right: 0;
    left: inherit;
  }

  .nav-wrapper {
    display: none;
  }

  .explore-btn {
    display: none;
  }

  .banner-hover-text {
    top: 28%;
  }
}
</style>
